import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../../theme';

export default StyleSheet.create({
  title: {
    fontFamily: textStyles.bold,
    fontSize: 16,
    color: colorPalette.grey9_5,
    marginTop: 8,
  },
  description: {
    fontFamily: textStyles.regular,
    fontSize: 13,
    color: colorPalette.grey9_5,
    textAlign: 'center',
    marginHorizontal: 16,
    marginTop: 8,
  },
  icon: {
    marginTop: 16,
  },
  countdown: {
    fontFamily: 'IRANYekan',
  },
});
